// image_utils.js

import { addUploadItem } from "../db/index_db_utils.js";
import { createS3UploadParams, uploadToS3V2 } from '../db/aws_s3_utils.js';
import { UpdateLocalStorage } from "../db/localstorage_utils.js";
import { triggerBackgroundSync } from './service_worker_utils.js';
import { jsonUploadTrigger } from './json_utils.js';
import config from "./conf.js";

/**
 * Orchestrator: Uploads the canvas image as a PNG to S3.
 * @param {Object} options - Contains dependencies and configuration.
 * @param {React.RefObject} options.canvasRef - Ref to the canvas element.
 * @param {Object} options.userData          - User data (UUID, examType, etc.).
 * @param {string} options.filenameSuffix    - Suffix for the uploaded file name.
 * @param {string} options.thisPage          - Identifier for the current screen/page.
 */
export async function uploadImageV2({ canvasRef, userData, filenameSuffix, thisPage }) {
  try {
    const canvas = canvasRef.current;
    if (!canvas) {
      throw new Error("Canvas element is not available");
    }

    // Convert canvas to a PNG blob.
    const contentType = "image/png"
    const dataURL = canvas.toDataURL(contentType);
    const response = await fetch(dataURL);
    const blob = await response.blob();

    // Create S3 upload parameters.
    const params = {
      baseUrl: config.COGNET_DB_API_URL,
      patientId: userData.UUID,
      dbName: userData.origin,
      testType: userData.examType,
      attempt: userData.attemptNumber,
      screenId: filenameSuffix,
      extension: "png",
      contentType: contentType,
      fileBuffer: blob
    }
    const key_params = createS3UploadParams(userData, blob, filenameSuffix, "png", "image/png");
    UpdateLocalStorage(key_params.Key, thisPage);
    jsonUploadTrigger({userData})
    try {
      await uploadToS3V2(params)
      // await uploadToS3(params);
    } catch (err) {
      console.warn('PUT failed, queueing for background‑sync:', err);
      await addUploadItem({ params });
      await triggerBackgroundSync();
    }
  } catch (error) {
    console.error("Error uploading image:", error);
  }
}
